export default "__VITE_ASSET__$N$aL2M2__"